import { combineReducers } from "@reduxjs/toolkit";
import assetLogonsReducer from "./assetLogonsSlice";
import taskLogonsReducer from "./taskLogonsSlice";

export default combineReducers({
  assetLogons: assetLogonsReducer,
  taskLogons: taskLogonsReducer,
});
